import React, { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom"
import { useNavigate } from "react-router-dom";
import { useServerConnection } from "../hooks/ServerConnection";
import { getRedirectURI } from "../utils/redirectURI";
import { useGitlabAccessToken } from "../hooks/GitlabAccessToken";

const ReceiveAccessCode = () => {
    const [accessToken, setAccessToken] = useGitlabAccessToken()
    const newAccessTokenRef = useRef<string>(null)
    const serverConnection = useServerConnection()
    const navigate = useNavigate()
    const [seachParams] = useSearchParams()

    useEffect(() => {
        async function getAccessTokenAndRedirect() {
            newAccessTokenRef.current = null

            const namespace = seachParams.get('namespace');
            const project = seachParams.get('project');
            const code = seachParams.get('code');
            const ref = seachParams.get('ref');

            const redirectURI = getRedirectURI({
                project,
                namespace,
                ref,
            })
            const token = await serverConnection.authorizeUser(code, redirectURI);
            newAccessTokenRef.current = token
            setAccessToken(token)
        }
        getAccessTokenAndRedirect()
    }, [seachParams, newAccessTokenRef])

    useEffect(() => {
        // wait for accessToken to be set
        if(accessToken && newAccessTokenRef.current === accessToken) {
            const namespace = seachParams.get('namespace');
            const project = seachParams.get('project');
            const ref = seachParams.get('ref');

            if(namespace && project) {
                navigate(`/confirm-vm-creation?project=${project}&namespace=${namespace}${ref ? `&ref=${ref}` : ''}`)
            } else {
                navigate('/')
            }
        }
    }, [seachParams, accessToken, newAccessTokenRef])

    return (
        <div/>
    )
}

export default ReceiveAccessCode